module.exports = __webpack_public_path__ + "images/homepage-step2.svg";


//////////////////
// WEBPACK FOOTER
// ./_common/images/homepage-step2.svg
// module id = 160
// module chunks = 1